import { render, staticRenderFns } from "./fundAllocation.vue?vue&type=template&id=2e4270b4&scoped=true"
import script from "./fundAllocation.vue?vue&type=script&lang=js"
export * from "./fundAllocation.vue?vue&type=script&lang=js"
import style0 from "./fundAllocation.vue?vue&type=style&index=0&id=2e4270b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4270b4",
  null
  
)

export default component.exports